<template>
  <div class="verval">
    <statistik :value="statistik" :gelombang="params.gelombang" :meta="metaIndex" />
    <!--daftar-->
    <v-card flat>
      <v-card-title class="pa-0">
        <base-table-header
          :btnDownload="allowDownload"
          @download="onDownloadList"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
        >
          <template v-slot:toolbar>
            <v-select
              class="mt-7"
              v-model="params.gelombang"
              :items="mGelombang"
              item-text="text"
              item-value="value"
              dense
              outlined
              @change="fetchData"
              style="max-width: 180px"
            />
          </template>
          <template v-slot:subtitle>
            <div class="body-1 black--text"> Daftar Kepala Sekolah</div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter ref="filter" title="Pilih Filter Status" :filtered="filtered" @save="filterSave" />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list three-line>
                <v-list-item class="px-0">
                  <v-list-item-avatar color="secondary">
                    <v-icon dark>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" md="4">
                        <div class="black--text subtitle-2 mb-0 body-1 font-weight-medium">
                          {{
                            $getDeepObj(item, 'psp_monevs.data.0.ptk.data.nama') ||
                              $getDeepObj(item, 'psp_pelaksana.data.ptk.data.nama') ||
                              '-'
                          }}
                        </div>
                        <div class="mb-0">
                          <span class="body-2">
                            <v-icon small left class="mr-1" style="margin-bottom: 3px">mdi-label-outline</v-icon>
                            {{
                              $getDeepObj(item, 'psp_monevs.data.0.ptk.data.no_ukg') ||
                                $getDeepObj(item, 'psp_monevs.data.0.ptk.data.ptk_id') ||
                                $getDeepObj(item, 'psp_pelaksana.data.ptk.data.id') ||
                                '-'
                            }}
                          </span>
                        </div>
                        <div class="black--text mb-0 mt-2">
                          {{ $getDeepObj(item, 'nama') || '-' }}
                        </div>
                        <div class="mb-0">
                          <span class="body-2">
                            <v-icon small left class="mr-1">mdi-home</v-icon>
                            {{ $getDeepObj(item, 'npsn') || '-' }}
                          </span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-row>
                          <template v-for="(laporan, id) in laporans()[params.gelombang]">
                            <v-col
                              cols="12"
                              sm="12"
                              :md="laporan.size || 12 / (laporans()[params.gelombang] || []).length"
                              :key="id"
                            >
                              <span class="body-2">{{ laporan.nama }}</span>
                              <div class="mt-1">
                                <v-chip
                                  :class="
                                    `${getStatus(
                                      laporan,
                                      $getDeepObj(item, 'psp_monevs.data') || [],
                                      'color'
                                    )} white--text`
                                  "
                                >
                                  {{ getStatus(laporan, $getDeepObj(item, 'psp_monevs.data') || [], 'text') }}
                                </v-chip>
                              </div>
                            </v-col>
                          </template>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="2">
                        <div><span class="body-2">Aksi</span></div>
                        <div>
                          <v-btn depressed color="primary" class="mb-1 text-capitalize" @click="onDetail(item)">
                            Lihat Laporan
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full ref="modal" title="Laporan Akhir IHT" mode="detail" auto-close>
      <component ref="formulir" :is="formulir.component" :detail="detail" :meta="meta" :gelombang="params.gelombang" />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import Statistik from './Statistik';
import Preview from './Preview';
import Detail from './Detail';
export default {
  name: 'Index',
  mixins: [list],
  components: { Statistik, Preview, Detail },
  props: {
    gelombangFsp: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      gelombang: 2,
      detail: {},
      meta: {},
      metaIndex: {},
      formulir: {},
      listLaporan: [
        {
          key: 'download-rekap',
          label: 'Rekapitulasi Laporan',
          acl: 'psp-monev-laporan.download-rekap',
          laporan_id: 'rekap',
          params: {},
        },
        {
          key: 'download-laporan',
          label: 'Laporan IHT 1',
          acl: 'psp-monev-laporan.download-laporan',
          laporan_id: 'iht1',
          gelombang: 1,
          params: { k_monev_laporan_psp: 1 },
        },
        {
          key: 'download-laporan',
          label: 'Laporan IHT 2',
          acl: 'psp-monev-laporan.download-laporan',
          laporan_id: 'iht2',
          gelombang: 1,
          params: { k_monev_laporan_psp: 2 },
        },
        {
          key: 'download-laporan',
          label: 'Laporan IHT 3',
          acl: 'psp-monev-laporan.download-laporan',
          laporan_id: 'iht3',
          gelombang: 1,
          params: { k_monev_laporan_psp: 3, sub: 'umum' },
        },
        {
          key: 'download-laporan',
          label: 'Laporan Pembukaan',
          acl: 'psp-monev-laporan.download-laporan',
          laporan_id: 'iht4',
          gelombang: 2,
          params: { k_monev_laporan_psp: 4 },
        },
        {
          key: 'download-laporan',
          label: 'Laporan Akhir',
          acl: 'psp-monev-laporan.download-laporan',
          laporan_id: 'iht5',
          gelombang: 2,
          params: { k_monev_laporan_psp: 5 },
        },
        {
          key: 'download-laporan',
          label: 'Laporan Rekap Peserta',
          acl: 'psp-monev-laporan.download-laporan',
          laporan_id: 'iht_peserta',
          gelombang: 1,
          params: { k_monev_laporan_psp: 3, sub: 'peserta' },
        },
        {
          key: 'download-laporan',
          label: 'Laporan Rekap Dukungan',
          acl: 'psp-monev-laporan.download-laporan',
          laporan_id: 'iht_laporan',
          gelombang: 1,
          params: { k_monev_laporan_psp: 3, sub: 'dukungan' },
        },
        {
          key: 'download-laporan',
          label: 'Laporan Rekap Hambatan',
          acl: 'psp-monev-laporan.download-laporan',
          laporan_id: 'iht_hambatan',
          gelombang: 1,
          params: { k_monev_laporan_psp: 3, sub: 'hambatan' },
        },
        {
          key: 'download-laporan',
          label: 'Laporan Rekap Pengajar',
          acl: 'psp-monev-laporan.download-laporan',
          laporan_id: 'iht_pengajar',
          gelombang: 1,
          params: { k_monev_laporan_psp: 3, sub: 'pengajar' },
        },
        {
          key: 'download-laporan',
          label: 'Laporan Rekap Penyelenggaraan',
          acl: 'psp-monev-laporan.download-laporan',
          laporan_id: 'iht_pelaksanaan',
          gelombang: 1,
          params: { k_monev_laporan_psp: 3, sub: 'pelaksanaan' },
        },
      ],
    };
  },
  computed: {
    ...mapState('preferensi', {
      prefConfig: (state) => state.data?.config ?? {},
    }),
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    allowDownload() {
      return this.listLaporan.filter((item) => this.$allow(item.acl)).length > 0;
    },

    mGelombang() {
      let gelombangs = this.$getDeepObj(this.prefConfig, 'pelatih_ahli.profil-administrasi.gelombangs') || [];
      if ((this.gelombangFsp || []).length) {
        gelombangs = this.gelombangFsp;
      }

      return gelombangs.reverse().map((gelombang) => {
        return {
          text: `Angkatan ${gelombang}`,
          value: gelombang,
        };
      });
    },
  },
  created() {
    let gelombangs = this.$getDeepObj(this.prefConfig, 'pelatih_ahli.profil-administrasi.gelombangs') || [];
    if ((this.gelombangFsp || []).length) {
      gelombangs = this.gelombangFsp;
    }

    this.params.gelombang = [...[], ...gelombangs].pop();
  },
  methods: {
    ...mapActions('diklatIht', ['fetch', 'getDetail', 'downloadList']),
    ...mapActions('master', ['getMasters']),

    fetchData() {
      return new Promise((resolve) => {
        const params = Object.assign({}, this.params);
        const attr = Object.assign({}, this.attr);
        this.fetch({ params, attr }).then(({ data, meta }) => {
          this.data = data || [];
          this.metaIndex = meta || {};
          this.total = meta?.total || 0;
          this.pageTotal = meta?.last_page || 1;
          this.params.limit = meta?.per_page || this.params.limit;
          this.statistik = Array.isArray(meta?.statistik) ? {} : meta?.statistik || {};
          resolve(true);
        });
      });
    },

    laporans() {
      if (this.metaIndex.is_vokasi && this.params.gelombang === 3) {
        return {
          3: [
            { id: 6, nama: 'Laporan Pembukaan' },
            { id: 7, nama: 'Laporan Akhir' },
            { id: 8, nama: 'Laporan Evaluasi' },
          ],
        };
      }

      return {
        1: [
          { id: 1, nama: 'IHT 1' },
          { id: 2, nama: 'IHT 2' },
          { id: 3, nama: 'IHT 3' },
        ],
        2: [
          { id: 4, nama: 'Laporan Pembukaan ' },
          { id: 5, nama: 'Laporan Akhir' },
        ],
        3: [
          { id: 6, nama: 'Laporan Pembukaan' },
          { id: 7, nama: 'Laporan Akhir' },
        ],
      };
    },

    getStatus(iht, monevs, type = 'text') {
      let result = { text: 'Belum', color: 'grey' };
      const laporan = monevs.filter((item) => {
        return +item.k_monev_laporan_psp === +iht.id;
      });
      let isTerlaksana =
        monevs.filter((item) => {
          return +item.is_terlaksana === 1;
        }).length > 0;

      if (this.$getDeepObj(laporan[0], 'k_verval_psp') > 1) {
        result = {
          text: 'Sudah',
          color: 'green',
        };
      }

      if (!isTerlaksana && this.params.gelombang < 3) {
        isTerlaksana = true;
      }

      if (monevs.length && !isTerlaksana) {
        result = {
          text: 'Tidak Ada',
          color: 'orange',
        };
      }

      return result[type];
    },

    async onDetail(monev) {
      const { data, meta } = await this.getDetail({
        id: monev.sekolah_id,
        params: { gelombang: this.params.gelombang },
      });

      let detail = {};
      for (const pspMonev of data) {
        detail[pspMonev.k_monev_laporan_psp] = Object.assign({}, pspMonev, { sekolah: meta.sekolah });
      }

      this.$set(this.formulir, 'component', this.params.gelombang >= 2 ? 'Detail' : 'Preview');
      this.detail = detail;
      this.meta = meta;
      this.$refs.modal.open();
      this.$nextTick(() => {
        if (this.$refs.formulir.reset) {
          this.$refs.formulir.reset();
        }
      });
    },

    onDownloadList() {
      const M_LAPORAN = (this.listLaporan || []).filter(
        (laporan) => !laporan.gelombang || (laporan.gelombang && +laporan.gelombang === +this.params.gelombang)
      );

      let url = {};
      this.$confirm('Pilih jenis Berkas yang ingin di Unduh?', 'Unduh Berkas', {
        tipe: 'info',
        icon: 'mdi-download',
        form: {
          desc: 'Laporan Berkas',
          render: (h) => {
            return h(
              'select',
              {
                class: 'custom-select',
                domProps: {
                  value: '',
                },
                on: {
                  input: function(event) {
                    url.dokumen = event.target.value;
                  },
                },
              },
              [
                h('option', { attrs: { value: '' } }, '-- Pilih Laporan Berkas --'),
                M_LAPORAN.filter((laporan) => this.$allow(laporan.acl)).map((item) =>
                  h('option', { attrs: { value: item.laporan_id } }, item.label)
                ),
              ]
            );
          },
        },
        lblConfirmButton: 'Unduh',
      }).then(() => {
        if (!url.dokumen) {
          this.$error('Silakan pilih laporan yang ingin diunduh!');
          return;
        }

        const laporan = this.listLaporan.find((item) => item.laporan_id === url.dokumen) || {};

        const params = Object.assign({}, laporan.params);
        this.downloadList({ params, url: laporan.key }).then((url) => {
          this.$downloadFile(url);
        });
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
